import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const requiredIndicator = css`
  margin-left: 5px;
`;

export const label = (theme: ExactTheme) =>
  css({
    ...theme.inputLabelV2,
    // alignItems: "center",
  });

export const container = css`
  display: flex;
  align-items: center;
  gap: 5px;
  //height: 16px;
`;

export const additionalElems = css({
  marginLeft: "auto",
  display: "flex",
  alignItems: "center",
  gap: 8,
});
